import React, { useState, useEffect } from 'react';

type ButtonSliderProps = {
  buttonItems: string[];
  onButtonClick: ( index: number ) => void;
  baseClassName?: string;
  textColor?: string;
  activeTextColor?: string;
  sliderBg?: string;
  borderArrowColor?: string;
  selectedIndex?: number;
};

const ButtonSlider: React.FC<ButtonSliderProps> = ( {
  buttonItems,
  onButtonClick,
  baseClassName = 'bg-gray-200',
  textColor = 'text-black',
  activeTextColor = 'text-gray-base',
  sliderBg = 'bg-orange-base',
  selectedIndex,
} ) => {
  const [ activeIndex, setActiveIndex ] = useState( selectedIndex ?? 0 );

  useEffect( () => {
    if ( selectedIndex !== undefined && selectedIndex !== activeIndex ) {
      setActiveIndex( selectedIndex );
    }
  }, [ selectedIndex ] );

  useEffect( () => {
    if ( activeIndex >= buttonItems.length ) {
      setActiveIndex( 0 );
      onButtonClick( 0 );
    }
  }, [ buttonItems, activeIndex, onButtonClick ] );

  const handleMenuClick = ( index: number ) => {
    setActiveIndex( index );
    onButtonClick( index );
  };

  if ( buttonItems.length === 0 ) {
    return null;
  }

  return (
    <>
      <div className={`relative flex flex-wrap rounded-md group py-1 ${baseClassName}`}>
        {buttonItems.map( ( item, index ) => {
          const isActiveItem = activeIndex === index;
          return (
            <button
              key={index}
              className={`
                w-full text-sm leading-6 font-comfortaa font-semibold
                flex-1 text-center transition duration-300 ease-in-out z-10
              `}
              style={{
                left: `${activeIndex * ( 100 / buttonItems.length )}%`,
              }}
              onClick={() => {return handleMenuClick( index );}}
            >
              <div
                className={`trans-fast flex items-center justify-center px-2 py-1
                  ${ isActiveItem ? activeTextColor : textColor }
                  ${ isActiveItem ? sliderBg : '' }
                  ${ isActiveItem ? 'rounded-md' : '' }
                `}
              >
                <h2 className="px-4 py-1 w-full truncate text-sm leading-6 text-center font-comfortaa font-semibold">
                  {item}
                </h2>
              </div>
            </button>
          );
        } ) }
      </div>
    </>
  );
};

export default ButtonSlider;
